import client, { endpoints } from '../api/client';
import { INVITES } from '../constants/actionTypes';

const errMsg = (e) => e?.response?.data?.error || e?.message || 'Unknown error.';

export const fetchInvites = (params = {}) => async (dispatch) => {
  dispatch({ type: INVITES.LIST_REQUEST });
  try {
    const { data } = await client.get(endpoints.invites.list, { params });
    dispatch({ type: INVITES.LIST_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: INVITES.LIST_FAILURE, payload: errMsg(e) });
  }
};
export const createInvite = (payload) => async (dispatch) => {
  try {
    const { data } = await client.post(endpoints.invites.create, payload);
    dispatch({ type: INVITES.CREATE, payload: data.invite });
    return { ok: true, invite: data.invite };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const bulkInvite = (rows) => async (dispatch) => {
  try {
    const { data } = await client.post(endpoints.invites.bulk, { rows });
    (data.created || []).forEach(i => dispatch({ type: INVITES.CREATE, payload: i }));
    return { ok: true, created: data.created, skipped: data.skipped };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const resendInvite = (id) => async (dispatch) => {
  try {
    const { data } = await client.post(endpoints.invites.resend(id));
    dispatch({ type: INVITES.UPDATE, payload: data.invite });
    return { ok: true };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const revokeInvite = (id) => async (dispatch) => {
  try {
    await client.delete(endpoints.invites.revoke(id));
    dispatch({ type: INVITES.REMOVE, payload: id });
    return { ok: true };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const lookupInvite = (token) => async () => {
  try {
    const { data } = await client.get(endpoints.invites.byToken(token));
    return { ok: true, invite: data.invite };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const acceptInvite = (token, payload) => async (dispatch) => {
  try {
    const { data } = await client.post(endpoints.invites.accept, { token, ...payload });
    if (data.token) localStorage.setItem('auth_token', data.token);
    return { ok: true, user: data.user };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
